import { MultiSelect } from "@/components/atoms";

interface DropdownInputProps {
    options: string[];
    selected: string[];
    multi: boolean;
    title: string;
    onChange: (selected: string[]) => void;
}

export function DropdownInput({ options, selected, multi, title, onChange }: DropdownInputProps) {
    const selectedIds = selected.map((s) => options.indexOf(s)).filter((i) => i >= 0);

    const handleChange = (ids: number[]) => {
        if (multi) {
            onChange(ids.map((i) => options[i]).filter(Boolean));
        } else {
            // Single-select: pick the newly added id, or fall back to first
            const prevIds = selected.map((s) => options.indexOf(s)).filter((i) => i >= 0);
            const newlyAdded = ids.filter((id) => !prevIds.includes(id));
            const targetId = newlyAdded.length > 0 ? newlyAdded[0] : ids[0];
            const val = targetId !== undefined ? options[targetId] : undefined;
            onChange(val ? [val] : []);
        }
    };

    return (
        <>
            <MultiSelect
                options={options.map((o, i) => ({ id: i, label: o }))}
                selectedIds={selectedIds}
                onChange={handleChange}
                placeholder={`Select ${title.toLowerCase()}...`}
                searchable
                showSelectAll={false}
            />
            {!multi && (
                <p className="text-xs text-gray-400">
                    {selected.length === 0 ? "Select an option above, then click Continue" : "Click Continue when you're ready"}
                </p>
            )}
        </>
    );
}
